import React, { useState, useEffect } from "react";
import useSalesReceiptStore from "../store";

export default function Liabilities() {
  const { liabilities, setLiabilities } = useSalesReceiptStore();
  const initialLiability = { liability_name: "", liability_amount: 0 };
  const [newLiability, setNewLiability] = useState(initialLiability);
  const [editIndex, setEditIndex] = useState(-1);
  const [totalLiabilities, setTotalLiabilities] = useState(0);

  useEffect(() => {
    const sum = liabilities.reduce((acc, item) => acc + parseFloat(item.liability_amount), 0);
    setTotalLiabilities(sum);
  }, [liabilities]);

  const handleLiabilityChange = (e, index) => {
    const updatedLiabilities = [...liabilities];
    updatedLiabilities[index].liability = e.target.value;
    setLiabilities(updatedLiabilities);
  };

  const handleAmountChange = (e, index) => {
    const updatedLiabilities = [...liabilities];
    updatedLiabilities[index].liability_amount = parseFloat(e.target.value);
    setLiabilities(updatedLiabilities);
  };

  const handleAddLiability = () => {
    if (editIndex === -1) {
      setLiabilities([...liabilities, newLiability]);
    } else {
      const updatedLiabilities = [...liabilities];
      updatedLiabilities[editIndex] = newLiability;
      setLiabilities(updatedLiabilities);
      setEditIndex(-1);
    }
    setNewLiability(initialLiability);
  };

  const handleDeleteLiability = (index) => {
    const updatedLiabilities = [...liabilities];
    updatedLiabilities.splice(index, 1);
    setLiabilities(updatedLiabilities);
  };

  if (liabilities.length === 0) {
    return null
  }

  return (
    <div className="mx-3 my-3 border-white rounded shadow-sm p-3">
      <h4 className="my-1">Liabilities</h4>
      <div className="my-2"
      style={{
        minHeight: "87px",
      }}
      >
        {liabilities.map((item, index) => (
          <div key={index} className="d-flex mb-3">
            <label className="mx-1 w-100 form-control">{item.liability_name}</label>
            <input
              type="number"
              className="form-control"
              name="liability_amount"
              value={parseFloat(item.liability_amount)}
              onChange={(e) => handleAmountChange(e, index)}
              readOnly
              disabled
            />
          </div>
        ))}
      </div>
      <hr className="featurette-divider" />
      <div className="row d-flex justify-content-end align-items-center mt-3">
        <div className="col-md-6 d-flex">
          <h5 className="text-muted">Total Liabilities:</h5>
          <p className="fw-bold fs-5">${totalLiabilities.toFixed(2)}</p>
        </div>
      </div>
      <hr className="featurette-divider" />
    </div>
  );
}
